import React from 'react'
import { useIntl } from 'react-intl'

const EmptySearchResult = () => {
  const { formatMessage } = useIntl()
  return (
    <div className={'font-Roboto text-20 md:text-28'}>
      {formatMessage({
        defaultMessage: 'No result found.',
        id: 'msp.product_list.no_result'
      })}
    </div>
  )
}

export default EmptySearchResult
